import React from 'react';

const STAGES = [
  { key:'backlog',      label:'Backlog',                    color:'bg-slate-100  border-slate-300'   },
  { key:'em_contato',   label:'Em Contato',                 color:'bg-blue-50    border-blue-200'    },
  { key:'qualificacao', label:'Qualificação',               color:'bg-cyan-50    border-cyan-200'    },
  { key:'aguardando',   label:'Aguard. Materiais',          color:'bg-yellow-50  border-yellow-200'  },
  { key:'proposta',     label:'Proposta / Call',            color:'bg-orange-50  border-orange-200'  },
  { key:'criando_proposta', label:'Criando Proposta',       color:'bg-amber-50   border-amber-300'   },
  { key:'negociacao',   label:'Negociação',                 color:'bg-purple-50  border-purple-200'  },
  { key:'enviar_contrato',      label:'Enviar Contrato',           color:'bg-violet-50  border-violet-200'  },
  { key:'aguardando_assinatura', label:'Aguard. Assinatura',       color:'bg-fuchsia-50 border-fuchsia-200' },
  { key:'fechado',      label:'Fechado ✓',                  color:'bg-green-50   border-green-200'   },
  { key:'perdido',      label:'Perdido ✗',                  color:'bg-red-50     border-red-200'     },
  // Fila de retomada: lead perdido que chegou na data marcada para chamar de novo.
  // Fica depois de Perdido de propósito: é trabalho do dia, não degrau do funil.
  { key:'repescagem',   label:'Repescagem 🔄',              color:'bg-indigo-50  border-indigo-300' },
];

const INTERACTION_TYPES = ['ligacao','email','reuniao','whatsapp','outro'];

const SERVICE_TYPES = [
  'Google Ads','Google Ads + Meta Ads','Meta Ads','LinkedIn Ads','TikTok Ads',
  'Google Ads + LP','Meta Ads + LP','Landing Pages',
  'Consultoria de Google Ads','Consultoria de Meta Ads',
  'Performance Completa','CRM','SEO',
];

const LEAD_ORIGINS = [
  { key:'carteira',           label:'Carteira',              emoji:'💼' },
  { key:'indicacao_carteira', label:'Indicação de Carteira', emoji:'👥' },
  { key:'indicacao',          label:'Indicação',             emoji:'🤝' },
  { key:'evento',             label:'Evento',                emoji:'🎪' },
  { key:'linketr',            label:'Linketr',               emoji:'🔗' },
  { key:'parceiro',           label:'Parceiro',              emoji:'🏢' },
  { key:'instagram',          label:'Instagram',             emoji:'📸' },
  { key:'site',               label:'Site (formulário)',     emoji:'🌐' },
  { key:'whatsapp',           label:'WhatsApp do site',      emoji:'💬' },
  { key:'lead_hunting',       label:'Lead Hunting',          emoji:'🎯' },
  { key:'outro',              label:'Outro',                 emoji:'📌' },
];

// RECURRENCE_OPTIONS mantido apenas para 'unica'; meses agora são números livres

const RECURRENCE_OPTIONS = [
  { key:'unica', label:'Execução única', months:1 },
];

// Retorna o número de meses da recorrência (suporta formatos legados '3m','6m','12m' e novo '6','12' etc.)

// As empresas saíram daqui na fase A: viraram documentos em `companies/{id}`.
// Quem precisa de nome e cor usa `lib/empresas.js`.

// ─── TodoItem ─────────────────────────────────────────────

const PRIORITIES = [
  { key: 'alta',  label: 'Alta',  dot: 'bg-red-500',    text: 'text-red-500',    bg: 'bg-red-50',    next: 'media' },
  { key: 'media', label: 'Média', dot: 'bg-orange-400',  text: 'text-orange-500', bg: 'bg-orange-50', next: 'baixa' },
  { key: 'baixa', label: 'Baixa', dot: 'bg-blue-400',    text: 'text-blue-400',   bg: 'bg-blue-50',   next: 'alta'  },
];

const LOSS_REASON_LABELS = {
  sem_resposta: 'Cliente não respondeu mais',
  preco: 'Preço',
  concorrente: 'Fechou com concorrente',
  atendimento_ineficiente: 'Atendimento ineficiente',
  outros: 'Outros',
};

const TEMP_LEVELS = [
  { v:1, emoji:'❄️', label:'Muito frio',   bg:'bg-blue-100',   text:'text-blue-700',   border:'border-blue-200'   },
  { v:2, emoji:'🌥',  label:'Frio',         bg:'bg-sky-50',     text:'text-sky-600',    border:'border-sky-200'    },
  { v:3, emoji:'🌤',  label:'Morno',        bg:'bg-yellow-50',  text:'text-yellow-700', border:'border-yellow-200' },
  { v:4, emoji:'🔥',  label:'Quente',       bg:'bg-orange-100', text:'text-orange-700', border:'border-orange-200' },
  { v:5, emoji:'🚀',  label:'Muito quente', bg:'bg-red-100',    text:'text-red-700',    border:'border-red-200'    },
];

const INTER_TYPES_QUICK = [
  { key:'whatsapp', icon:'💬', label:'WhatsApp' },
  { key:'ligacao',  icon:'📞', label:'Ligação'  },
  { key:'email',    icon:'📧', label:'E-mail'   },
  { key:'reuniao',  icon:'🤝', label:'Reunião'  },
  { key:'outro',    icon:'📝', label:'Outro'    },
];

const CAMPOS_CARD = [
  { key:'valor',      label:'Valor',              padrao:true  },
  { key:'origem',     label:'Origem',             padrao:true  },
  { key:'vendedor',   label:'Vendedor',           padrao:true  },
  { key:'temperatura',label:'Temperatura',        padrao:true  },
  { key:'contato',    label:'Nome do contato',    padrao:true  },
  { key:'servico',    label:'Serviço',            padrao:true  },
  { key:'parceiros',  label:'Parceiros',          padrao:true  },
  { key:'esfriando',  label:'Aviso de esfriando', padrao:true  },
  { key:'proposta',   label:'Link da proposta',   padrao:true  },
  { key:'whatsapp',   label:'Botão de WhatsApp',  padrao:true  },
  { key:'previsao',   label:'Previsão de fechamento', padrao:false },
];

const CARD_PADRAO = Object.fromEntries(CAMPOS_CARD.map(c => [c.key, c.padrao]));

const LIMITE_ESFRIANDO = {
  backlog: 30, em_contato: 10, qualificacao: 10, aguardando: 15,
  proposta: 7, criando_proposta: 5, negociacao: 7,
  enviar_contrato: 3, aguardando_assinatura: 5,
};

const ESFRIANDO_PADRAO = 14;

/** Quantos dias o lead está parado na etapa atual. */

const AUDIT_ICONS = {
  stage_change:'🔀', lead_create:'✨', lead_update:'✏️', lead_delete:'🗑',
  interaction_add:'💬', interaction_delete:'💬', timeline_add:'📝', timeline_delete:'📝',
  deal_update:'💰', lead_edit:'✏️', rollback:'↩️',
};

const AUDIT_ROLLBACK_TYPES = ['stage_change','lead_create','lead_update','lead_delete','interaction_add','interaction_delete','timeline_add','timeline_delete','deal_update'];

const WA_ICON = <svg viewBox="0 0 24 24" className="w-3 h-3 fill-current"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>;

// ─── Audio helpers ─────────────────────────────────────────

export { AUDIT_ICONS, AUDIT_ROLLBACK_TYPES, CAMPOS_CARD, CARD_PADRAO, ESFRIANDO_PADRAO, INTERACTION_TYPES, INTER_TYPES_QUICK, LEAD_ORIGINS, LIMITE_ESFRIANDO, LOSS_REASON_LABELS, PRIORITIES, RECURRENCE_OPTIONS, SERVICE_TYPES, STAGES, TEMP_LEVELS, WA_ICON };

// ─── WhatsApp: mensagens prontas (roadmap #3) ──────────────
// {nome} primeiro nome do contato · {empresa} empresa do lead · {vendedor} quem envia · {nossa} nossa empresa
const WA_TEMPLATES = [
  { key:'primeiro', label:'Primeiro contato', text:'Olá {nome}, tudo bem? Aqui é {vendedor}, da {nossa}. Vi o contato sobre a {empresa} e queria entender melhor o momento de vocês. Podemos conversar?' },
  { key:'retomar',  label:'Retomar conversa', text:'Oi {nome}, passando para retomar nossa conversa sobre a {empresa}. Ficou alguma dúvida?' },
  { key:'cobrar',   label:'Cobrar retorno',   text:'{nome}, tudo certo? Só confirmando se você recebeu o material que enviei. Qualquer coisa, estou por aqui.' },
];
export { WA_TEMPLATES };
